import { CUSTOM_OPTION } from "./types";

interface OtherRowProps {
    radioName: string;
    isSelected: boolean;
    customText: string;
    onSelect: () => void;
    onTextChange: (text: string) => void;
}

export function OtherRow({ radioName, isSelected, customText, onSelect, onTextChange }: OtherRowProps) {
    return (
        <>
            <label
                className={`flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2.5 text-sm transition-colors ${
                    isSelected
                        ? "border-[#079a95] bg-[#079a95]/5 text-[#079a95]"
                        : "border-[#e2e8f0] bg-white text-gray-500 hover:border-[#079a95]/50 hover:bg-[#079a95]/5"
                }`}
            >
                <input
                    type="radio"
                    name={radioName}
                    value={CUSTOM_OPTION}
                    checked={isSelected}
                    onChange={onSelect}
                    className="h-4 w-4 shrink-0 accent-[#079a95]"
                />
                <span className="font-medium italic">Other (type your own answer)</span>
            </label>
            {isSelected && (
                <input
                    autoFocus
                    type="text"
                    placeholder="Type your answer..."
                    value={customText}
                    onChange={(e) => onTextChange(e.target.value)}
                    className="w-full rounded-lg border border-[#079a95] bg-white px-3 py-2 text-sm text-gray-800 outline-none placeholder:text-gray-400 focus:ring-2 focus:ring-[#079a95]/20"
                />
            )}
        </>
    );
}
